import { getAuthorizationBearer } from "./endpoint";

export async function getFacilities(quicksearch?: string)
    : Promise<any> {
    let parameters = [
        quicksearch ? `fn=${quicksearch}` : '',
    ];

    let urlParameters = parameters.some(s => s !== '')
        ? `?${parameters.filter(s => s !== '').join('&')}` : '';

    let url: string = `api/scf/lookups/external/facilities${urlParameters}`;
    const response = (await fetch(url, {
        method: 'GET',
        headers: new Headers({
            "Authorization": getAuthorizationBearer()
        }),
    }));
    const json = await response.json();

    return json.map(i => ({
        id: +i.id,
        name: `${i.value} - ${i.id}`
    }))
}